export default __webpack_public_path__ + "static/B0148-04b4b1f62046d2c0278fa3162e07ab83.png";